module.exports = __webpack_public_path__ + "img/Butterfly_00078.fb176a74.png";